import AGREGAR_OFICIO_AUTORIZACION from '@/graphql/mutations/administracion/programacion/oficiosautorizacion/agregarOficioAutorizacion.gql';
import REMOVER_OFICIO_AUTORIZACION from '@/graphql/mutations/administracion/programacion/oficiosautorizacion/removerOficioAutorizacion.gql';
import ACTUALIZAR_OFICIO_AUTORIZACION from '@/graphql/mutations/administracion/programacion/oficiosautorizacion/actualizarOficioAutorizacion.gql';
import OFICIOS_AUTORIZACION from '@/graphql/querys/administracion/programacion/oficiosautorizacion/oficiosautorizacion.gql';

export default {
  methods: {
    // Guardar Oficio de Autorización
    async mixAgregarOficio() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { oficio } = this;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_OFICIO_AUTORIZACION,
          variables: { oficio },
          update: (store, { data: { agregarOficioAutorizacion } }) => {
            const query = {
              query: OFICIOS_AUTORIZACION,
            };
            const { oficiosAutorizacion } = store.readQuery(query);
            const oficiosAutorizacionCopia = oficiosAutorizacion.slice();
            oficiosAutorizacionCopia.push(agregarOficioAutorizacion);
            store.writeQuery({
              ...query,
              data: {
                oficiosAutorizacion: oficiosAutorizacionCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarOficio() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_OFICIO_AUTORIZACION,
        variables: {
          id: this.oficioAutorizacionEliminar.id,
        },
        update: (store) => {
          const query = {
            query: OFICIOS_AUTORIZACION,
          };
          const { oficiosAutorizacion } = store.readQuery(query);
          const index = oficiosAutorizacion
            .findIndex(
              (oficio) => oficio.id === this.oficioAutorizacionEliminar.id,
            );

          if (index !== -1) {
            oficiosAutorizacion.splice(index, 1);
          }
          store.writeQuery({
            ...query,
            data: {
              oficiosAutorizacion,
            },
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEditarOficio() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { oficio } = this;
      const idOficio = this.oficioAutorizacionEditar.id;
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_OFICIO_AUTORIZACION,
          variables: { id: idOficio, oficio },
          update: (store, { data: { actualizarOficioAutorizacion } }) => {
            const query = {
              query: OFICIOS_AUTORIZACION,
            };
            const { oficiosAutorizacion } = store.readQuery(query);
            const index = oficiosAutorizacion
              .findIndex(
                (o) => o.id === this.oficioAutorizacionEditar.id,
              );
            const oficiosAutorizacionCopia = oficiosAutorizacion.slice();
            oficiosAutorizacionCopia.splice(index, 1, actualizarOficioAutorizacion);
            // oficiosAutorizacionCopia.push(actualizarOficioAutorizacion);
            store.writeQuery({
              ...query,
              data: {
                oficiosAutorizacion: oficiosAutorizacionCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
